import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-financial_time",
  "use": "icon-financial_time-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-financial_time\">\n<g id=\"icon-financial_time_icon/24/&#230;&#156;&#128;&#232;&#191;&#145;&#232;&#174;&#191;&#233;&#151;&#174;\">\n<g id=\"icon-financial_time_icon/24/&#230;&#156;&#128;&#232;&#191;&#145;&#232;&#174;&#191;&#233;&#151;&#174;_2\">\n<path id=\"icon-financial_time_Subtract\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.3316 12.1614H16.3364C16.7026 12.1614 17 12.4569 17 12.8208C17 13.1869 16.7026 13.4824 16.3342 13.4824H10.6658C10.2974 13.4824 10 13.1869 10 12.8208V7.14405C10 6.77795 10.2974 6.48242 10.6658 6.48242C11.0342 6.48242 11.3316 6.77795 11.3316 7.14405V12.1614Z\" fill=\"#3B60F6\" />\n</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/financial_time.svg
// module id = EA0j
// module chunks = 102